// removed by extract-text-webpack-plugin
module.exports = {"loaderWrap":"_1UDHG","small":"_1Fvgq"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Loader/Loader.scss
// module id = 153
// module chunks = 0 1